// @ai-generated 2026-08-05T00:00:00+00:00 by malte.ulfers@tngtech.com using Claude Opus 4.7
import { IconChevronDown, IconChevronRight, IconLink } from '@tabler/icons-react';
import { useState } from 'react';
import { lookupField } from '../fieldMetadata';
import type { SynqoRuleset, SynqoRulesetReferenceCondition } from '@Model';
import { ACCENT } from './accent';
import { ConditionCard } from './ConditionCard';
import { ConditionVisitor } from './ConditionVisitor';

interface RulesetReferenceRendererProps {
    node: SynqoRulesetReferenceCondition;
    referencedRulesets: Record<string, SynqoRuleset>;
}

export function RulesetReferenceRenderer({ node, referencedRulesets }: RulesetReferenceRendererProps) {
    const [expanded, setExpanded] = useState(false);
    const targetLabel = node.target ? lookupField(node.target.path)?.label ?? node.target.path : null;
    const referenceKey = `${node.root_entity_type}:${node.ruleset_key}`;
    const referenced = referencedRulesets[referenceKey];
    const canExpand = referenced !== undefined;

    return (
        <ConditionCard accent={ACCENT.ruleset_ref}>
            <button
                type="button"
                onClick={() => (canExpand ? setExpanded((prev) => !prev) : undefined)}
                disabled={!canExpand}
                className={`flex w-full items-center gap-2 text-left text-sm ${canExpand ? 'hover:text-(--mantine-color-text-7) cursor-pointer' : 'cursor-default'}`}
                aria-expanded={expanded}
            >
                {canExpand &&
                    (expanded ? (
                        <IconChevronDown size={14} className="shrink-0 text-(--mantine-color-text-4)" />
                    ) : (
                        <IconChevronRight size={14} className="shrink-0 text-(--mantine-color-text-4)" />
                    ))}
                <IconLink size={16} className={`shrink-0 ${ACCENT.ruleset_ref.icon}`} />
                {targetLabel ? (
                    <>
                        <span className="font-medium">{targetLabel}</span>
                        <span className="text-(--mantine-color-text-5)">erfüllt Regelsatz</span>
                    </>
                ) : (
                    <span className="text-(--mantine-color-text-5)">erfüllt Regelsatz</span>
                )}
                {referenced ? (
                    <span className="font-medium text-(--mantine-color-text-7)">{referenced.title}</span>
                ) : (
                    <span className="italic text-(--mantine-color-text-4)">
                        externer Regelsatz ({node.root_entity_type})
                    </span>
                )}
                <span className="rounded bg-(--mantine-color-secondary-3) px-2 py-0.5 font-mono text-xs text-(--mantine-color-text-5)">
                    {referenceKey}
                </span>
            </button>
            {expanded && referenced && (
                <div className="mt-3 pl-4 border-l-2 border-(--mantine-color-accent-2)">
                    <ConditionVisitor node={referenced.root} referencedRulesets={referencedRulesets} />
                </div>
            )}
        </ConditionCard>
    );
}
